export enum AssetState {
  Blocked,
  Active,
}
